import { View } from "ui/atoms/view";
import { Link } from "expo-router";
import { Text } from "react-native";

export interface MenuOption {
  label: string;
  href: string;
  selected?: boolean;
}

interface Props {
  options: MenuOption[];
}

export function MenuSection({ options }: Props) {
  return (
    <View className="bg-secondary-0 rounded-lg px-4 py-5">
      <View className="gap-y-2">
        {options.map((option) => (
          <Link key={option.label} href={option.href}>
            <View
              className={`p-2 rounded-lg flex ${
                option.selected ? "bg-primary-0 font-medium" : "font-normal"
              }`}
            >
              <Text>{option.label}</Text>
            </View>
          </Link>
        ))}
      </View>
    </View>
  );
}
